module.exports = __webpack_public_path__ + "static/feature_marty_mthood-2f67f5e3a7146095fd91b285ee055699.jpg";